import { Typography } from '@material-ui/core';
import { Link as RRLink } from 'react-router-dom';
import Breadcrumb from '../Breadcrumb';
import PlanDocument1 from './../../assets/PlanDocument-1.png';
import PlanDocument2 from './../../assets/PlanDocument-2.png';
import PlanDocument3 from './../../assets/PlanDocument-3.png';
import PlanDocument4 from './../../assets/PlanDocument-4.png';
import PlanDocument5 from './../../assets/PlanDocument-5.png';
import PlanDocument6 from './../../assets/PlanDocument-6.png';
import PlanDocument7 from './../../assets/PlanDocument-7.png';
import HelpFooter from './HelpFooter';
import useStyles from './useStyles';
import { useTranslation } from 'react-i18next';

export default function PlanDocument() {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <div className={classes.root}>
      <Breadcrumb
        name="topicName"
        data={{
          helpTopic: t('help.topics.documents.label'),
          helpTopicId: 'documents',
          topicName: t('help.subtopics.planDocument'),
          topicNameId: 'plan-document'
        }}
      />
      <Typography className={classes.title} component="p" variant="h4">
        {t('help.pages.planDocument.title')}
      </Typography>
      <Typography variant="body1">{t('help.pages.planDocument.step1')}</Typography>
      <img className={classes.media} src={PlanDocument1} alt={`${String(t('help.stepAltPrefix'))}1`} />
      <Typography variant="body1">{t('help.pages.planDocument.step2')}</Typography>
      <img className={classes.media} src={PlanDocument2} alt={`${String(t('help.stepAltPrefix'))}2`} />
      <Typography variant="body1">{t('help.pages.planDocument.step3')}</Typography>
      <img className={classes.media} src={PlanDocument3} alt={`${String(t('help.stepAltPrefix'))}3`} />
      <Typography variant="body1">{t('help.inputDocumentInformation')}</Typography>
      <Typography className={classes.textLeftMargin} variant="body2">
        {t('help.pages.planDocument.step41')}
      </Typography>
      <Typography className={classes.textLeftMargin} variant="body2">
        {t('help.pages.planDocument.step42')}{' '}
        <RRLink to="/helps/permissions/document-access-control">
          {t('help.links.whatIsDocumentAccessControl')}
        </RRLink>
      </Typography>
      <Typography className={classes.textLeftMargin} variant="body2">
        {t('help.pages.planDocument.step43')}
      </Typography>
      <Typography className={classes.textLeftMargin} variant="body2">
        {t('help.pages.planDocument.step44')}
      </Typography>
      <Typography className={classes.textLeftMargin} variant="body2">
        {t('help.pages.planDocument.step45')}
      </Typography>
      <img className={classes.media} src={PlanDocument4} alt={`${String(t('help.stepAltPrefix'))}4`} />
      <Typography variant="body1">{t('help.pages.planDocument.step5')}</Typography>
      <Typography className={classes.textLeftMargin} variant="body2">
        <u>{t('help.purposeDefinition')}</u>
      </Typography>
      <Typography className={classes.textLeftMargin} variant="body2">
        {t('help.purpose.IFS')}
      </Typography>
      <Typography className={classes.textLeftMargin} variant="body2">
        {t('help.purpose.IFI')}
      </Typography>
      <Typography className={classes.textLeftMargin} variant="body2">
        {t('help.purpose.IFR')}
      </Typography>
      <Typography className={classes.textLeftMargin} variant="body2">
        {t('help.purpose.IFA')}
      </Typography>
      <Typography className={classes.textLeftMargin} variant="body2">
        {t('help.purpose.IFD')}
      </Typography>
      <Typography className={classes.textLeftMargin} variant="body2">
        {t('help.purpose.IFE')}
      </Typography>
      <Typography className={classes.textLeftMargin} variant="body2">
        {t('help.purpose.IFP')}
      </Typography>
      <Typography className={classes.textLeftMargin} variant="body2">
        {t('help.purpose.IFC')}
      </Typography>
      <Typography className={classes.textLeftMargin} variant="body2">
        {t('help.purpose.IFF')}
      </Typography>
      <img className={classes.media} src={PlanDocument5} alt={`${String(t('help.stepAltPrefix'))}5`} />
      <Typography variant="body1">{t('help.pages.planDocument.step6')}</Typography>
      <img className={classes.media} src={PlanDocument6} alt={`${String(t('help.stepAltPrefix'))}6`} />
      <Typography variant="body1">{t('help.pages.planDocument.step7')}</Typography>
      <img className={classes.media} src={PlanDocument7} alt={`${String(t('help.stepAltPrefix'))}7`} />
      <HelpFooter />
    </div>
  );
}
